// import i18n from '@/lang/lang'
// import router from '@/router'
const debug = require('debug')('OD::Lib:MatchPointHelper')

const libLogs = false

/*
function getInterval(performances) {
  const time = performances[performances.length - 1] - performances[performances.length - 2]
  return Math.round(time, 2) + ' m.'
}
function getAllInterval(performances) {
  const time = performances[performances.length - 1] - performances[0]
  return Math.round(time, 2) + ' m.'
}
*/

export default {
  config(sport) {
    if (libLogs) debug('sport', { sport })
    const base = { type: sport.type || 'pointBase' }
    return Object.assign(base, {
      sportId: sport.id,
      sport: sport.sport || '',
      name: sport.name,
      pointControls: sport.pointControls || [{ text: '', description: '', num: 1 }],
      pointBasicControls: sport.pointBasicControls || [{ text: '', description: '', num: 1 }],
      numSetsToWin: parseInt(sport.numSetsToWin),
      numSetsToPlay: parseInt(sport.numSetsToPlay),
      regularSetPointsToWin: parseInt(sport.regularSetPointsToWin),
      lastSetPointsToWin: parseInt(sport.lastSetPointsToWin),
      setMinDifferenteToWin: parseInt(sport.setMinDifferenteToWin),
      maxNumSets: parseInt(sport.maxNumSets),
      maxSetScore: parseInt(sport.maxSetScore),
      downtimeBySet: parseInt(sport.downtimeBySet),
      numChangesBySet: parseInt(sport.numChangesBySet),
      actionControls: sport.actionControls || [],
      actionBasicControls: sport.actionBasicControls || [],
      timeControls: sport.timeControls || [],
      globalControls: sport.globalControls || [],
      num: sport.num || 0,
      opposite: sport.opposite || false,
      maxPlayerNum: parseInt(sport.maxPlayerNum),
      numPlayerInSet: parseInt(sport.numPlayerInSet),
      numExtraPlayerInSet: parseInt(sport.numExtraPlayerInSet),
      maxFaultsBySet: parseInt(sport.maxFaultsBySet),
      hideDowntimes: sport.hideDowntimes,
    })
  },
  matchSetEnd(config, set, i) {
    if (libLogs) debug('matchSetEnd', { config, set, i })
    let ended = false
    const maxScore =
      i === config.maxNumSets - 1 ? config.lastSetPointsToWin : config.regularSetPointsToWin
    ended =
      (set.l >= maxScore || set.v >= maxScore) &&
      Math.abs(set.l - set.v) >= config.setMinDifferenteToWin

    if (config.maxSetScore) {
      if (!ended && (set.l >= config.maxSetScore || set.v >= config.maxSetScore)) ended = true
    }
    return ended
  },
  getMatchResult(config, match) {
    if (libLogs) debug('getMatchResult', { config, match })
    let localResult = 0
    let visitorResult = 0
    if (match.sets) {
      match.sets.map((set, i) => {
        if (this.matchSetEnd(config, match.sets[i], i)) {
          localResult += set.l > set.v ? 1 : 0
          visitorResult += set.l < set.v ? 1 : 0
        }
      })
    }
    return { l: localResult, v: visitorResult }
  },
  isMatchOnline(config, match, matchFinish) {
    if (libLogs) debug('isMatchOnline', { config, match, matchFinish })
    let inPlay = false
    match.sets.map(set => {
      if (set.l > 0 || set.v > 0) {
        inPlay = true
      }
    })
    if (inPlay) {
      return !matchFinish
    }
    return false
  },
  isMatchStarted(config, match) {
    if (libLogs) debug('isMatchStarted', { config, match })
    let inPlay = false
    match.sets.map(set => {
      if (set.l > 0 || set.v > 0) {
        inPlay = true
      }
    })
    return inPlay
  },
  isMatchFinish(config, match, matchResult) {
    if (libLogs) debug('isMatchFinish', { config, match, matchResult })
    /*
    if (libLogs)
      debug('isMatchFinish', {
        totalSets: matchResult.l + matchResult.v,
        numSetsToPlay: config.numSetsToPlay,
        l_matchResult: matchResult.l,
        v_matchResult: matchResult.v,
        numSetsToWin: config.numSetsToWin,
      })
    */
    return (
      matchResult.l + matchResult.v >= config.numSetsToPlay &&
      (matchResult.l >= config.numSetsToWin ||
        matchResult.v >= config.numSetsToWin ||
        matchResult.l + matchResult.v >= config.maxNumSets)
    )
  },
  isButtonDisabled(control, config, match, i, action, team, matchFinished) {
    if (libLogs)
      debug('isButtonDisabled', {
        control,
        config,
        match,
        i,
        action,
        team,
        matchFinished,
      })

    if (!matchFinished) {
      if (control.num > 0) {
        return false
      }

      if (action === 'remove') {
        if (i > 0) {
          return false
        }
      }
      if (!this.matchSetEnd(config, match.sets[i], i)) {
        if (match.sets[i].events && match.sets[i].events.length > 0) {
          return false
        }
      }
      return true
    } else {
      if (action === 'remove') {
        if (i > 0) {
          return false
        }
      }
      return true
    }
  },
  getMaxNumDowntimesBySet(config) {
    if (libLogs) debug('getMaxNumDowntimesBySet', { config })
    return config.downtimeBySet
  },
}
